import { RefObject, useEffect } from 'react';

// Makes every `tbody tr` (and its `td`s) inside `ref` HTML5-draggable while `enabled`. Runs on every
// render — PrimeReact exposes no row-level `draggable` prop, and rows are re-created on pagination /
// expand / data load, so the attribute must be re-applied imperatively each time. The actual
// drag-start handler lives on an ancestor (event delegation); this only marks the rows as draggable.
export const useDraggableRows = (ref: RefObject<HTMLElement>, enabled: boolean): void => {
  useEffect(() => {
    if (!enabled || !ref.current) return;
    ref.current.querySelectorAll('tbody tr').forEach((tr) => {
      tr.setAttribute('draggable', 'true');
      tr.querySelectorAll('td').forEach((td) => td.setAttribute('draggable', 'true'));
    });
  });
};
